import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { API_BASE_URL } from './config';
import "./style.css";

const CastingManagement = () => {
  const [selectedOption, setSelectedOption] = useState("全部機台");
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState([]);
  const [uniqueModels, setUniqueModels] = useState([]);

  const navigate = useNavigate();

  const userRole = localStorage.getItem('role');

  useEffect(() => {
    const fetchData = async () => {
      const username = localStorage.getItem('username') || '未知使用者';
      try {
        const response = await axios.get(`${API_BASE_URL}/getdata/castingData`, {
          headers: { 'x-username': username }
        });
        setData(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  const handleCastingCreate = () => {
    navigate('/casting-create');
  };

  //除了我指定的，其他LocalStorage都清除
  Object.keys(localStorage).forEach((key) => {
    if (!['role', 'username', 'isLoggedIn', 'department'].includes(key)) {
      localStorage.removeItem(key);
    }
  });

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleCastingInfo = (id) => {
    const TempData = data[id - 1];
    navigate(`/casting-info/${id}`, { state: { TempData } });
  };

  const handleCastingSFRF = (id) => {
    const TempData = data[id - 1];
    navigate(`/casting-solo-frequency-response-function/${id}`, { state: { TempData } });
  };

  const handleDeleteMachine = async (id) => {
    try {
      await axios.post(`${API_BASE_URL}/deleteCastingData`, { id });
      setData(data.filter((machine) => machine._id !== id));
      console.log(`Machine with id ${id} deleted successfully`);
    } catch (error) {
      console.error(`Error deleting machine with id ${id}:`, error);
    }
  };

  useEffect(() => {
    const models = [...new Set(data.map(machine => machine.machineModel))];
    setUniqueModels(models);
  }, [data]);

  const filteredData = selectedOption === "全部機台" ? data : data.filter((machine) => machine.machineModel === selectedOption);

  const filteredAndSearchedData = filteredData.filter((machine) => {
    const company = machine.company ? machine.company.toLowerCase() : '';
    const client = machine.client ? machine.client.toLowerCase() : '';
    const machineModel = machine.machineModel ? machine.machineModel.toLowerCase() : '';
    const machineForm = machine.machineForm ? machine.machineForm.toLowerCase() : '';
    return (
      company.includes(searchTerm.toLowerCase()) ||
      machineModel.includes(searchTerm.toLowerCase()) ||
      machineForm.includes(searchTerm.toLowerCase()) ||
      client.includes(searchTerm.toLowerCase())
    );
  });

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <div>
      <div style={{ height: '35px', width: '100%' }}></div>
      <nav aria-label="breadcrumb">
        <ol className="d-flex breadcrumb" style={{ width: '80%', margin: '0 auto' }}>
          <li
            className="breadcrumb-item"
            aria-current="page"
            style={{ color: '#5B82B1', fontWeight: 'bold', fontSize: '15px' }}
          >
            鑄件資料庫
          </li>
        </ol>
      </nav>
      <div style={{ height: '35px', width: '100%' }}></div>
      <form className="d-flex flex-wrap mb-3" style={{ height: 'auto', width: '80.9%', margin: '0 auto' }} onSubmit={handleSearchSubmit}>
        <div className="me-auto p-2">
          <div className="d-flex bd-highlight">
            <span style={{ fontSize: '16px', display: 'flex', alignItems: 'center', minWidth: '80px' }}>型號選擇：</span>
            <div>
              <select
                className="form-select"
                style={{ width: '150px' }}
                value={selectedOption}
                onChange={handleSelectChange}
              >
                <option value="全部機台">全部機台</option>
                {uniqueModels.map(model => (
                  <option key={model} value={model}>{model}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="p-2">
          <input
            type="search"
            className="form-control"
            placeholder="請輸入關鍵字"
            value={searchTerm}
            onChange={handleSearchChange}
            style={{ width: '150px', minWidth: '150px', maxWidth: '150px' }} // 固定寬度
          />
        </div>
        <div className="p-2">
          <button
            className="btn-create btn-primary"
            type="button"
            onClick={handleCastingCreate}
          >
            +
          </button>
        </div>
      </form>

      <div>
        <div
          className="table-responsive"
          style={{
            maxHeight: '720px',
            maxWidth: '80%',
            overflowY: 'auto',
            overflowX: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <table className="table table-striped text-center table-hover table-bordered">
            <thead className="custom-thead">
              <tr>
                <th>#</th>
                <th>鑄件</th>
                <th>料號</th>
                <th>型號</th>
                <th>機台型式</th>
                <th>功能</th>
              </tr>
            </thead>
            <tbody>
              {filteredAndSearchedData.map((machine, index) => (
                <tr key={machine._id}>
                  <td>{index + 1}</td>
                  <td>{machine.company}</td>
                  <td>{machine.client}</td>
                  <td>{machine.machineModel}</td>
                  <td>{machine.machineForm}</td>
                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      <button
                        className="btn-view"
                        onClick={() => handleCastingInfo(index + 1)}
                      >
                        檢視
                      </button>
                      <button
                        className="btn-view"
                        onClick={() => handleCastingSFRF(index + 1)}
                      >
                        函數
                      </button>
                      {userRole === 'admin' && (
                        <button className="btn-delete" onClick={() => handleDeleteMachine(machine._id)}>
                          刪除
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div style={{ height: '60px', width: '100%' }}></div>
    </div>
  );
};

export default CastingManagement;